module.exports = {
  apiServer: (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'test') ? 'https://devapius1.processplan.com' : 'https://apius1.processplan.com',
  siteFiles: 'https://s3.amazonaws.com/ppwebsitefiles'
}
